import * as React from 'react';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import ChevronRight from '@mui/icons-material/ChevronRight';
import { SettingsModuleConfig } from '../../config/modules.config';
import { brand } from 'themes/brand';

interface ModuleCardProps {
  config: SettingsModuleConfig;
  enabledCount: number;
  total: number;
  onClick: () => void;
}

export const ModuleCard: React.FC<ModuleCardProps> = ({
  config,
  enabledCount,
  total,
  onClick,
}) => {
  const Icon = config.icon;

  return (
    <Card
      variant="outlined"
      sx={{ mb: 2, borderRadius: 3, overflow: 'hidden' }}
    >
      <CardActionArea onClick={onClick}>
        <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box
            sx={{
              width: 48,
              height: 48,
              borderRadius: 2.5,
              bgcolor: brand.tint,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            <Icon sx={{ color: brand.primary, opacity: 0.85 }} />
          </Box>

          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography variant="subtitle1" fontWeight={600}>
              {config.label}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {config.description}
            </Typography>
            <Divider sx={{ my: 1 }} />
            <Typography variant="caption" color="text.secondary">
              {`${enabledCount} de ${total} funcionalidade${
                total === 1 ? '' : 's'
              } ativas`}
            </Typography>
          </Box>

          <ChevronRight color="action" />
        </CardContent>
      </CardActionArea>
    </Card>
  );
};
